var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3AutoGarageDoors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 27.08L21 14.28 0 29.11V59h76V27l-36.4.08zM38 55H4V31.22l17-12 17 11.69V55zm34 0H42v-3h30v3zm0-7H42v-3h30v3zm0-7H42v-3h30v3zm0-7H42v-3h30v3zM11 48.77h4.6l1.85-5h6.23l1.73 5h5.21L23 29.11h-4.33L11 48.77zM20.76 35l1.78 5.26h-3.68l1.9-5.26z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Auto_garage_doors.6103ac2c.svg";
export { SvgE3AutoGarageDoors as ReactComponent };